import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

export default function PortalSettings({ onLogout }) {
 const [notif, setNotif] = useState(true);
 const [lang, setLang] = useState('EN');

 return (
 <div className="space-y-4">
 <h2 className="text-xl font-semibold">Settings</h2>
 <Card>
 <CardContent className="p-4 space-y-3">
 <div className="flex items-center justify-between">
 <Label>Notifications (mock)</Label>
 <Switch checked={notif} onCheckedChange={setNotif} />
 </div>
 <div className="flex items-center justify-between">
 <Label>Language</Label>
 <div className="text-sm">{lang}</div>
 </div>
 <Button variant="outline" onClick={onLogout}>Sign out</Button>
 </CardContent>
 </Card>
 </div>
 );
}
